<template>
  <div class='StorageCardStore'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:cardNature="{ item }">
        <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
    <Modal :show.sync="isShow" @getList="getItemList" v-if="isShow"/>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import Modal from './components/Modal.vue'
import { optionsDataReplace } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    Modal
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '入库人员：', prop: 'inboundUser', placeholder: '请输入入库人员' },
          { type: 'Input', label: '入库序列ID：', prop: 'inboundSn', placeholder: '请输入入库序列ID' },
          { type: 'Date', label: '入库日期：', prop: 'inboundDate', placeholder: '请选择入库日期' },
          { type: 'Select', label: '审核状态：', prop: 'inboundStatus', options: this.$label.ExamStatus, placeholder: '请选择审核状态' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', options: [], props: this.$map.typeProps, placeholder: '请选择卡类型' }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      isShow: false,
      Table: { // 表格
        primaryBtn: {
          show: true,
          html: '储值卡入库',
          handle: () => this.isShow = true
        },
        data: [],
        column: [
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardNature', label: '卡种类', slot: true },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'remaining', label: '余额' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'inboundStatusStr', label: '审核状态' },
          { prop: 'denomination', label: '面值(元)' },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'stateText', label: '卡状态' },
          { prop: 'inboundTime', label: '入库日期' },
          { prop: 'inboundSn', label: '入库序列ID' },
          { prop: 'inboundUserName', label: '入库人员' }
        ]

      }
    }
  },
  // 方法集合
  methods: {
    searchHandleForm () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },
    getItemList () {
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getStoreCardListApi(params).then(res => {
        pager.count = res?.data?.total || 0
        Table.data = (res?.data?.list || []).map((item) => ({
            ...item,
            stateText: item.state.text,
          }))
      })
    },
    // 卡类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
    init () {
      this.getCardTypeList()
      this.getItemList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },

}
</script>
<style lang='scss' scoped>

</style>
